export const transactionReportCols = function (withStatementData) {
    const defaultCols =  [ {
        field: "bankName",
        title_key: 'BANK_NAME'
    },{
        field: "bankPlace",
        title_key: 'BANK_PLACE'
    },{
        field: "bic",
        title_key: 'BIC'
    },{
        field: "accountNumber",
        title_key: 'ACCOUNT_NUMBER'
    },{
        field: "currencyCode",
        title_key: 'CURRENCY_CODE'
    },{
        field: "shortName",
        title_key: 'SHORT_NAME'
    },{
        field: "userDefinedAlias1",
        title_key: 'EXPORT_NAME'
    },{
        field: "userNumber",
        title_key: 'USER_NUMBER'
    }];

    const defaultColsEnd = [{
        field: "bookingDate",
        title_key: 'BOOK_DATE'
    }, {
        field: "valueDate",
        title_key: 'VALUE_DATE'
    }, {
        field: "amount",
        title_key: 'AMOUNT'
    }, {
        field: "transactionType",
        title_key: 'TRANSACTION_TYPE'
    }, {
        field: "accountOwnerRef",
        title_key: 'ACC_OWN_REF'
    }, {
        field: "bankReference",
        title_key: 'BANK_REF'
    }, {
        field: "supplementaryText",
        title_key: 'SUPPLEMENT_TEXT'
    }, {
        field: "bookingText",
        title_key: 'BOOK_TEXT'
    }];

    const BALANCE_COL = {
        field: "balance",
        title_key: 'BALANCE'
    };

    const withStDataCols = [{
        field: "openingDate",
        title_key: 'OPENING_DATE'
    }, {
        field: "openingBalance",
        title_key: 'OPEN_BAL'
    }, {
        field: "closingDate",
        title_key: 'CLOSING_DATE'
    }, {
        field: "closingBalance",
        title_key: 'CLOSE_BAL'
    }, {
        field: "creditSum",
        title_key: 'CREDIT_SUM'
    }, {
        field: "debitSum",
        title_key: 'DEBIT_SUM'
    }, {
        field: "infoToAccOwner",
        title_key: 'INF_TO_ACCOWN'
    }];

    const cols = withStatementData ?
        defaultCols.concat(withStDataCols).concat(defaultColsEnd) : defaultCols.concat(defaultColsEnd);
    if (!withStatementData) {
        cols.push(BALANCE_COL);
    }

    return cols;
}
